import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CategoryAggregateRankingPage } from '~/features/rankings/components/RankingDetailPage'

const categoryRankingSearchSchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  region: z.string().optional(),
})

export const Route = createFileRoute('/{-$locale}/_public/rankings/category/$year/$categorySourceId')({
  validateSearch: categoryRankingSearchSchema,
  component: CategoryAggregateRankingPage,
})
